export enum Notification {
    SlotOpen = 'SlotOpen',
    NoOpenSlot = 'NoOpenSlot',
}

export class NotificationEntry {
    constructor(
        public type: Notification,
        public date: Date) { }
}
